export const blockIconsContentRemoveCircleOutline = (
	<span className='material-symbols-outlined'>remove_circle_outline</span>
);
